import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c96be7fa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c96be7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96be7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c96be7fa')) {
      api.createRecord('c96be7fa', component.options)
    } else {
      api.reload('c96be7fa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c96be7fa&scoped=true&", function () {
      api.rerender('c96be7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24SOmIuxubEzt/JS/comp/GuestBox.vue"
export default component.exports